<template>
  <div>
    <h2 class="col-lg-12 text-center mb-3">{{ $t('addProduct') }}</h2>
    <FormProduct @submit-requested="submitRequested"></FormProduct>
  </div>
</template>
 
<script>
import { mapState, mapActions } from 'vuex'
import FormProduct from '../forms/FormProduct.vue'

  export default {
  components: { FormProduct },
  methods: {
    ...mapActions('products', ['addProduct']),
    submitRequested (inputProduct) {
      this.addProduct(inputProduct);
    },
  }

  }
</script> 
 
<style scoped>
thead > tr > th
{
  text-align: unset !important;
}
</style> 